import { Haptics, ImpactStyle } from '@capacitor/haptics';

export async function hapticImpact(style: ImpactStyle = ImpactStyle.Medium) {
  try {
    await Haptics.impact({ style });
  } catch (e) {
    // Fail silently if not on device
  }
}
